import React from 'react'
import {Row} from '@modifi/ui'
import {useInputValue} from '@modifi/plugin-forms'
import {
  DIRECTOR_POLITICALLY_EXPOSED,
  DIRECTOR_POLITICALLY_EXPOSED_REASON,
  withHideIfNotVisible,
  useInputNameSpecificTranslationKey,
  InputComponent,
  RadioGroupComponent,
  InputTooltipInfo,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {TranslateFn} from '../../../../../types/common'

type PoliticallyExposedInputRowProps = {
  t: TranslateFn
}

const PoliticallyExposedInputRow: React.FC<PoliticallyExposedInputRowProps> = ({t}) => {
  const {value} = useInputValue({
    name: DIRECTOR_POLITICALLY_EXPOSED,
    defaultValue: false,
  })
  const inputNameSpecific = useInputNameSpecificTranslationKey()

  const politicallyExposedRadioOptions = [
    {
      label: t(inputNameSpecific(DIRECTOR_POLITICALLY_EXPOSED, 'value.true')),
      value: true,
      colProps: {
        auto: true,
      },
    },
    {
      label: t(inputNameSpecific(DIRECTOR_POLITICALLY_EXPOSED, 'value.false')),
      value: false,
      colProps: {
        auto: true,
      },
    },
  ]

  return (
    <>
      <Row mb={16}>
        <FormInputComponentCol
          t={t}
          inputName={DIRECTOR_POLITICALLY_EXPOSED}
          inputComponent={RadioGroupComponent}
          options={politicallyExposedRadioOptions}
          // colProps={{md: 12}}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={DIRECTOR_POLITICALLY_EXPOSED} t={t} />,
          }}
        />
        {value && (
          <FormInputComponentCol
            t={t}
            inputName={DIRECTOR_POLITICALLY_EXPOSED_REASON}
            inputComponent={InputComponent}
            // colProps={{md: 12}}
            inputProps={{
              labelAddition: (
                <InputTooltipInfo inputName={DIRECTOR_POLITICALLY_EXPOSED_REASON} t={t} />
              ),
            }}
          />
        )}
      </Row>
    </>
  )
}

export default withHideIfNotVisible(PoliticallyExposedInputRow, DIRECTOR_POLITICALLY_EXPOSED)
